import LFCBaseCharts from '_components/charts/base/LFCBaseCharts';
import {colorPallet} from '_themes/color-pallet/ColorPallet';
import * as echarts from 'echarts';
import {useTranslation} from 'react-i18next';

/**
 * 引数
 */
interface Props {
  title: string;
  source: any | {};
  xData?: any;
  yAxisName?: string;
  grid?: {
    top?: number | string;
    bottom?: number | string;
    left?: number | string;
    right?: number | string;
  };
  color?: any | {};
  exportData?: any;
  exportFields?: any;
  exportFilename?: string;
  height?: string;
  onClick?: (prm: {data: any}) => void;
  zoomCharts?: any;
  zoomChartsClose?: any;
  zoomChartId?: string;
  zoomStatus?: boolean;
  showCP?: string;
}

/**
 * LFCChartsBar
 * @param props
 * @returns
 */
const LFCChartsLineMulti = (props: Props) => {
  const {t} = useTranslation();
  const legendChange = (data: any) => {
    let graph: any = document.getElementById(
      props.zoomChartId !== undefined ? props.zoomChartId : 'graph'
    );
    let graphZoom: any = document.getElementById('graphZoom');
    let echartsInstance: any;

    if (!props.zoomStatus && graphZoom === null) {
      echartsInstance = echarts.getInstanceByDom(graph.firstChild);
    } else {
      echartsInstance = echarts.getInstanceByDom(graphZoom.firstChild);
    }

    switch (data.name) {
      case '移動範囲Rm':
        if (data.selected.移動範囲Rm) {
          echartsInstance.dispatchAction({
            type: 'legendSelect',
            name: t('移動範囲Rs')
          });
        } else {
          echartsInstance.dispatchAction({
            type: 'legendUnSelect',
            name: t('移動範囲Rm')
          });
        }
        // echartsInstance.dispatchAction({
        //   type: 'legendUnSelect',
        //   name: '標準偏差S'
        // })
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: t('範囲')
        });
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: 'Cp'
        });
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: 'Cpk'
        });
        break;
      case '標準偏差':
        // echartsInstance.dispatchAction({
        //   type: 'legendUnSelect',
        //   name: '移動範囲Rm'
        // })
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: t('範囲')
        });
        if (data.selected.標準偏差) {
          echartsInstance.dispatchAction({
            type: 'legendSelect',
            name: t('標準偏差')
          });
        } else {
          echartsInstance.dispatchAction({
            type: 'legendUnSelect',
            name: t('標準偏差')
          });
        }
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: 'Cp'
        });
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: 'Cpk'
        });
        break;
      case '範囲':
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: t('移動範囲Rm')
        });
        if (data.selected.範囲) {
          echartsInstance.dispatchAction({
            type: 'legendSelect',
            name: t('範囲')
          });
        } else {
          echartsInstance.dispatchAction({
            type: 'legendUnSelect',
            name: t('範囲')
          });
        }
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: t('標準偏差')
        });
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: 'Cp'
        });
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: 'Cpk'
        });
        break;
      case 'Cp':
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: t('移動範囲Rm')
        });
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: t('標準偏差')
        });
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: t('範囲')
        });
        if (data.selected.Cp) {
          echartsInstance.dispatchAction({
            type: 'legendSelect',
            name: 'Cp'
          });
        } else {
          echartsInstance.dispatchAction({
            type: 'legendUnSelect',
            name: 'Cpk'
          });
        }
        echartsInstance.dispatchAction({
          type: 'legendSelect',
          name: 'Cpk'
        });
        break;
      case 'Cpk':
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: t('移動範囲Rm')
        });
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: t('標準偏差')
        });
        echartsInstance.dispatchAction({
          type: 'legendUnSelect',
          name: t('範囲')
        });
        echartsInstance.dispatchAction({
          type: 'legendSelect',
          name: 'Cp'
        });
        if (data.selected.Cpk) {
          echartsInstance.dispatchAction({
            type: 'legendSelect',
            name: 'Cpk'
          });
        } else {
          echartsInstance.dispatchAction({
            type: 'legendUnSelect',
            name: 'Cpk'
          });
        }
        break;
    }
  };

  let legendSelected: any = {
    移動範囲Rm: true,
    範囲: false,
    標準偏差: true,
    Cp: false,
    Cpk: false
  };

  return (
    <LFCBaseCharts
      option={{
        title: {
          text: props.title
        },
        grid: {
          left: props.grid !== undefined ? props.grid.left : '8%',
          right: props.grid !== undefined ? props.grid.right : '5%',
          bottom: props.grid !== undefined ? props.grid.bottom : '20%',
          top: props.grid !== undefined ? props.grid.top : '15%'
        },
        legend: {
          type: 'scroll',
          bottom: 0,
          itemWidth: 11,
          textStyle: {
            fontSize: 10
          },
          icon: 'circle',
          selected: legendSelected,
          data: [
            '標準偏差',
            '範囲',
            props.showCP === undefined || props.showCP !== '-' ? 'Cp' : '',
            'Cpk'
          ],
          formatter: (prm: any) => {
            return t(prm);
          }
        },
        tooltip: {
          trigger: 'axis',
          position: (point: any, params: any, dom: any, rect: any, size: any) => {
            // fixed at top
            return [point[0] + 20, '10%'];
          },
          formatter: (prm: any) => {
            let tmp: any;
            tmp = t('計測日時') + ':' + prm[0].axisValue + '<br/>';
            prm.forEach((a: any) => {
              if (a.value !== undefined) {
                tmp += a.marker + t(a.seriesName) + ':' + Number(a.value).toFixed(3) + '<br/>';
              } else {
                tmp += a.marker + t(a.seriesName) + ':' + t('データなし') + '<br/>';
              }
            });
            return tmp;
          }
        },
        dataZoom: [
          {
            type: 'inside'
            // minValueSpan: 3600 * 24 * 1000 * 7, // 最小ZOOM 7日分
          }
        ],
        color: props.color ? props.color : null,
        xAxis: {
          type: 'category',
          data: props.xData !== null ? props.xData : null,
          // data: null,
          axisLabel: {
            // interval: 0,
            rotate: '15',
            fontSize: 10
          }
          // splitLine: {
          //   show: true,
          // },
        },
        yAxis: [
          {
            type: 'value',
            name: props.yAxisName !== undefined ? props.yAxisName : '',
            nameLocation: 'end',
            position: 'left',
            // max: x_max,
            // nameTextStyle: {
            //   fontSize: 10,
            // },
            axisLabel: {
              // interval: 0,
              fontSize: 10
            }
          }
        ],
        series: [
          {
            name: '標準偏差',
            data:
              props.source.find((a: any) => a.name === '標準偏差S') !== undefined
                ? props.source.find((a: any) => a.name === '標準偏差S').data
                : undefined,
            stack: false,
            type: 'line',
            showSymbol: true,
            showAllSymbol: true,
            color: colorPallet[30]
          },
          {
            name: '範囲',
            data:
              props.source.find((a: any) => a.name === '範囲R') !== undefined
                ? props.source.find((a: any) => a.name === '範囲R').data
                : undefined,
            stack: false,
            type: 'line',
            showSymbol: true,
            showAllSymbol: true,
            color: colorPallet[31]
          },
          {
            name: 'Cp',
            data:
              props.source.find((a: any) => a.name === '工程能力Cp') !== undefined
                ? props.source.find((a: any) => a.name === '工程能力Cp').data
                : undefined,
            stack: false,
            type: 'line',
            showSymbol: true,
            showAllSymbol: true,
            color: colorPallet[32]
          },
          {
            name: 'Cpk',
            data:
              props.source.find((a: any) => a.name === '工程能力Cpk') !== undefined
                ? props.source.find((a: any) => a.name === '工程能力Cpk').data
                : undefined,
            stack: false,
            type: 'line',
            showSymbol: true,
            showAllSymbol: true,
            color: colorPallet[33]
          },
          {
            name:
              props.source !== undefined && props.source[4] !== undefined
                ? props.source[4].name
                : undefined,
            data:
              props.source !== undefined && props.source[4] !== undefined
                ? props.source[4].data
                : undefined,
            stack: false,
            type: 'line',
            showSymbol: true,
            showAllSymbol: true,
            color: colorPallet[34]
          }
        ]
      }}
      exportData={props.exportData}
      exportFields={props.exportFields}
      exportFilename={props.exportFilename}
      height={props.height !== undefined ? props.height : '300px'}
      onEvents={{
        click: (params: any) => {
          if (props.onClick != null) {
            props.onClick(params);
          }
        },
        legendselectchanged: (params: any) => {
          legendChange(params);
        }
      }}
      zoomCharts={props.zoomCharts ? props.zoomCharts : undefined}
      zoomChartsClose={props.zoomChartsClose ? props.zoomChartsClose : undefined}
      zoomChartId={props.zoomChartId ? props.zoomChartId : undefined}
      zoomStatus={props.zoomStatus ? props.zoomStatus : undefined}
    />
  );
};
export default LFCChartsLineMulti;
